module.exports = __webpack_public_path__ + "static/img/ic_arrow_left.8f1be1dd.svg";